// extracted by mini-css-extract-plugin
export default {"xxsm":"Title_xxsm__hYarM","xsm":"Title_xsm__oJvaF","sm":"Title_sm__XI6Ot","md":"Title_md__HxP4b","lg":"Title_lg__p9YjM"};